<template>
  <div class="animated revealUp">
    <div class="mb-3">
      <div class="section-title mb-3">{{ $t("transferStock") }}</div>
    </div>

    <div class="d-flex justify-content-between align-item-center mb-3"></div>
    <div class="edit-movie-container" style="zoom:0.9;">
      <form class="row">
        <!-- CINEMAS SELECTION -->
        <div class="row col-md-12 ml-1">
          <div class="col-md-3 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :disabled="isRoleID"
                  :text="selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Cinema"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchCinema($event.target.value)"
                      v-on:keydown="onSearchCinema($event.target.value)"
                      v-on:search="onSearchCinema($event.target.value)"
                      v-model="searchCinema"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(cinema, cinemaIndex) in cinemas"
                    :key="cinemaIndex"
                    href="#"
                    @click="onSelectCinema(cinema)"
                    >{{ cinema.cine_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <Tooltip :title="$t('fnbwastage_selectcinema')" />
              </div>
              <p
                v-if="submitted && selectedCinema.length == 0"
                class="error_message"
              >
                Please Select Cinema.
              </p>
            </div>
          </div>

          <div class="d-flex align-items-center mb-3 mx-4">
            <label class="mr-2">{{ $t("Transfer to Cinema") }}</label>
            <b-form-checkbox
              class="j-checkbox mb-1 pb-0"
              name="check-button"
              v-model="toCinema"
            ></b-form-checkbox>
          </div>
        </div>

        <!-- FROM STORE LEVEL -->
        <div class="row col-md-12 ml-1">
          <div class="col-md-3 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedStoreLevel.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("from") }}
                {{ $t("sm_store_name") }}</label
              >
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="selectedStoreLevel"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div
                    class="px-2 pb-2"
                    v-if="storeManagementsLevelsCopy.length > 0"
                  >
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Store"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchStore($event.target.value)"
                      v-on:keydown="onSearchStore($event.target.value)"
                      v-on:search="onSearchStore($event.target.value)"
                      v-model="searchStore"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Item, ItemIndex) in storeManagementsLevels"
                    :key="ItemIndex"
                    href="#"
                    @click="onSelectMainStoreLevel(Item)"
                    >{{ Item.sm_store_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <Tooltip :title="$t('fnbwastage_selectconcession')" />
              </div>
              <p
                v-if="submitted && selectedStoreLevel.length == 0"
                class="error_message"
              >
                Please Select from store name.
              </p>
            </div>
          </div>

          <!-- TO STORE LEVEL -->
          <div class="col-md-3 mb-4">
            <div class="dropdown-curve-container" v-if="!toCinema">
              <label :class="selectedFinalStore.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("to") }}
                {{ $t("sm_store_name") }}</label
              >
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="selectedFinalStore"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2" v-if="finalStoreLevelCopy.length > 0">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Store"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchToStore($event.target.value)"
                      v-on:keydown="onSearchToStore($event.target.value)"
                      v-on:search="onSearchToStore($event.target.value)"
                      v-model="searchToStore"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(Item, ItemIndex) in finalStoreLevel"
                    :key="ItemIndex"
                    href="#"
                    @click="onSelectStoreLevel(Item)"
                    >{{ Item.sm_store_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <Tooltip :title="$t('fnbwastage_selectconcession')" />
              </div>
              <p
                v-if="submitted && selectedFinalStore.length == 0"
                class="error_message"
              >
                Please Select to store name.
              </p>
            </div>

            <div class="dropdown-curve-container"  v-if="toCinema">
              <label :class="selected_to_cinema ? 'shift-up' : ''">
                {{ $tc("cinema", 1) }}
              </label>

              <multiselect
                v-model="selected_to_cinema"
                @select="onToCinemaSelect($event)"
                placeholder="Cinema"
                :options="getFilteredCinemas"
                label="cine_name"
                track-by="cine_id"
                :multiple="false"
                name="cine_name"
                id="cine_name"
                :allowEmpty="false"
                :showLabels="false"
              >
                <template slot="option" slot-scope="props"
                ><span
                  :class="
                    `${ allStoresCinemaIds.includes(props.option.cine_id) ? '' : 'ssmv-red-color' }`
                  "
                >{{ props.option.cine_name }}
                </span
                >
                </template>
              </multiselect>
            </div>
          </div>
        </div>

        <div
          v-for="(singleItem, singleItemIndex) in selectedRawMaterials"
          :key="singleItemIndex"
          class="col-md-12 ml-3 pt-3"
        >
          <div class="row" style="border-bottom: 0.1px solid lightgrey">
            <div class="col-md-3 mb-4">
              <div class="dropdown-curve-container">
                <label :class="singleItem.rm_name.length > 0 ? 'shift-up' : ''"
                  >{{ $t("select") }} {{ $tc("rawmaterials", 2) }}</label
                >
                <div class="d-flex justify-content-center align-items-center">
                  <b-dropdown
                    :text="singleItem.rm_name"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2" v-if="rawMaterialsCopy.length > 0">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search Raw Material"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchRawMaterial($event.target.value)"
                        v-on:keydown="onSearchRawMaterial($event.target.value)"
                        v-on:search="onSearchRawMaterial($event.target.value)"
                        v-model="searchRawMaterial"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(Item, ItemIndex) in rawMaterials"
                      :key="ItemIndex"
                      href="#"
                      @click="onSelectRawMaterial(Item, singleItemIndex)"
                      >{{ Item.rm_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                  <Tooltip :title="$t('fnbwastage_rawmaterials')" />
                </div>
                <span
                  class="mt-1"
                  v-if="singleItem.rm_name && singleItem.rm_name.length > 0 && !isNaN(singleItem.stockQuantity)"
                  >(Max Transfer Quantity {{ singleItem.stockQuantity }})</span
                >

                <p
                  v-if="submitted && singleItem.rm_name.length == 0"
                  class="error_message"
                >
                  Please Select Raw Material.
                </p>
              </div>
            </div>

            <div class="col-md-1 mb-4">
              <div class="dropdown-curve-container">
                <!-- <label
                  :class="singleItem.transfer_quantity.length > 0 ? 'shift-up' : '' "
                >{{ $t('select') }} {{ $tc('quantity', 2) }}</label>-->
                <div class="d-flex justify-content-center align-items-center">
                  <!-- <b-dropdown
                    :text="singleItem.transfer_quantity"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(Item,ItemIndex) in singleItem.stockQuantity"
                      :key="ItemIndex"
                      href="#"
                      @click="onSelectQty(Item,singleItemIndex)"
                    >{{ Item }}</b-dropdown-item>
                  </b-dropdown>-->
                  <!-- <b-input-group> -->
                  <div class="input-material">
                    <input
                      @input="calculateNetAmount(singleItem)"
                      :key="singleItemIndex+'transfer_qty'"
                      class="text-right"
                      v-model="singleItem.transfer_quantity"
                      style="border-radius: 10px"
                      type="text"
                      v-validate="'required|decimal:' + point"
                      name="transfer_qty"
                      id="transfer_qty"
                      placeholder="."
                      v-on:keyup="
                        CalculateSelectedRawMaterial(
                          $event.target.value,
                          singleItemIndex
                        )
                      "
                    />
                  </div>
                  <label class="shift-up">{{ $t("Qty") }}</label>

                  <!-- <template v-slot:append>
                      <b-dropdown variant="dropdown-curve" class="w-100">
                        <b-dropdown-item
                          v-for="(loop , key) in singleItem.stockQuantity"
                          :key="key"
                          v-on:click="onSelectQty(loop,singleItemIndex)"
                        >{{loop}}</b-dropdown-item>
                      </b-dropdown>
                  </template>-->
                  <!-- </b-input-group> -->
                  <!-- <Tooltip :title="$t('fnbwastage_selectquantity')" /> -->
                </div>
                <p
                  v-if="submitted && errors.has('transfer_qty')"
                  class="error_message"
                >
                  {{ errors.first("transfer_qty") }}
                </p>
              </div>
            </div>

            <div class="col-md-2 mb-4" v-if="toCinema">
              <div class="dropdown-curve-container">
                <div class="d-flex justify-content-center align-items-center">
                  <div class="input-material">
                    <input
                      @input="calculateNetAmount(singleItem)"
                      class="text-right"
                      v-model="singleItem.adjustment_rate"
                      style="border-radius: 10px"
                      type="text"
                      v-validate="{ required: toCinema, decimal: true }"
                      name="adjustment_rate"
                      id="adjustment_rate"
                      placeholder="."
                    />
                  </div>
                  <label class="shift-up">{{ $t("ratePerItem") }}</label>

                  <!-- <Tooltip :title="$t('fnbwastage_selectrate')" /> -->
                </div>
                <p
                  v-if="submitted && errors.has('adjustment_rate')"
                  class="error_message"
                >
                  {{ errors.first("adjustment_rate") }}
                </p>
              </div>
            </div>
            <div class="col-md-1 mb-4" v-if="toCinema">
              <div class="dropdown-curve-container">
                <div class="d-flex justify-content-center align-items-center position-relative">
                  <div class="input-material">
                    <input
                      @input="calculateNetAmount(singleItem)"
                      class="text-right"
                      v-model="singleItem.adjustment_tax"
                      style="border-radius: 10px"
                      type="text"
                      v-validate="{ required: toCinema, decimal: true }"
                      name="adjustment_tax"
                      id="adjustment_tax"
                      placeholder="."
                    />
                  </div>

                  <label
                    class="position-absolute"
                    style="padding: 0px; margin-top: 30px; font-size:10px;font-weight:bold"
                    v-if="singleItem.poi_tax_amount"
                  >Tax Amount ({{ singleItem.poi_tax_amount }})</label>

                  <label class="shift-up">{{ $t("Tax %") }}</label>

                  <!-- <Tooltip :title="$t('taxamount')" /> -->
                </div>
                <p
                  v-if="submitted && errors.has('adjustment_tax')"
                  class="error_message"
                >
                  {{ errors.first("adjustment_tax") }}
                </p>
              </div>
            </div>
             <div class="col-md-1 mb-4" v-if="toCinema">
              <div class="dropdown-curve-container">
                <div class="d-flex justify-content-center align-items-center">
                  <div class="input-material">
                    <input
                      @input="calculateNetAmount(singleItem)"
                      class="text-right"
                      :disabled="true"
                      v-model="singleItem.poi_total_amount"
                      style="border-radius: 10px"
                      type="text"
                      name="poi_total_amount"
                      id="poi_total_amount"
                      placeholder="."
                    />
                  </div>
                  <label class="shift-up">{{ $t("total") }}</label>
                </div>
                <p
                  v-if="submitted && errors.has('poi_total_amount')"
                  class="error_message"
                >
                  {{ errors.first("poi_total_amount") }}
                </p>
              </div>
            </div>

            <div class="col-md-2 mb-4">
              <div class="dropdown-curve-container">
                <label
                  :class="singleItem.uom_name.length > 0 ? 'shift-up' : ''"
                  >{{ $tc("uom", 2) }}</label
                >
                <div class="d-flex justify-content-center align-items-center">
                  <b-dropdown
                    disabled
                    :text="singleItem.uom_name"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(Item, ItemIndex) in singleItem.uom_units"
                      :key="ItemIndex"
                      href="#"
                      @click="onSelectUom(Item, singleItemIndex)"
                      >{{ Item.uom_unit }}</b-dropdown-item
                    >
                  </b-dropdown>
                  <!-- <Tooltip :title="$t('fnbwastage_rawmaterials')" /> -->
                </div>
                <p
                  v-if="submitted && singleItem.uom_name.length == 0"
                  class="error_message"
                >
                  Please Select Unit of measurement.
                </p>
              </div>
            </div>

            <div
              class="col-lg-1 d-flex align-items-center justify-content-center mb-4"
            >
              <button
                v-if="singleItemIndex == 0"
                @click.prevent.stop="addItem(singleItemIndex)"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click.prevent.stop="removeItem(singleItemIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            Transfer
          </button>
          <!-- <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button> -->
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <!-- <b-button class="btn-outline-grey" variant="default" to="fnb-wastage">{{ $t('cancel') }}</b-button> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";
import {groupBy} from "lodash";

export default {
  name: "TransferStocks",
  data() {
    return {
      point: 6,
      btenable: false,
      isRoleID: true,
      submitted: false,
      request_body: {
        cinema_id: null,
        transfer_from_store_management_id: null,
        transfer_to_store_management_id: null
        // transfer_quantity: null,
        // stock_id: null
      },
      selectedRawMaterials: [
        {
          rm_name: "",
          rm_id: null,
          stockQuantity: [],
          transfer_quantity: "",
          stock_id: null,
          uom_units: [],
          uom_name: "",
          conversion_formula: 1
        }
      ],
      searchCinema: "",
      searchStore: "",
      searchToStore: "",
      searchRawMaterial: "",
      cinemas: [],
      cinemasCopy: [],
      cinemasAll: [],
      cinemasCopyAll: [],
      rawMaterials: [],
      rawMaterialsCopy: [],
      storeManagementsLevels: [],
      storeManagementsLevelsCopy: [],
      finalStoreLevel: [],
      finalStoreLevelCopy: [],
      AllfinalStoreLevel: [],
      selectedCinema: "",
      selectedConcession: "",
      selectedStoreLevel: "",
      selectedFinalStore: "",
      selectedRawMaterial: "",
      stockQuantity: [],
      selectedQuantity: "",
      UnitMeasurement: [],
      toCinema: false,
      allStores: [],
      allStoresCinemaIds: [],
      selected_to_cinema: "",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(obj);
    this.getStores()
  },
  computed: {
    getFilteredCinemas () {
      let allcinemas = JSON.parse(JSON.stringify(this.cinemasCopyAll))
      let cinemas_to_filter = [] // [...this.allStoresCinemaIds]

      if (!!this.selectedCinema && !!this.request_body.cinema_id) {
        cinemas_to_filter.push(this.request_body.cinema_id)
      }

      allcinemas = allcinemas.filter(c => !cinemas_to_filter.includes(c.cine_id))

      return allcinemas
    },
  },
  mounted() {},
  methods: {
    calculateNetAmount: function(item) {

      // price = rate * qty
      // tax = (price * tax_percent) / 100
      // total_amount - price + tatx amount

      if (item.adjustment_rate && item.transfer_quantity) {
        item.poi_price = +parseFloat(item.adjustment_rate * item.transfer_quantity).toFixed(2);
      }

      if (item.poi_price && item.adjustment_tax) {
        item.poi_tax_amount = +parseFloat(
          (item.poi_price * item.adjustment_tax) / 100
        ).toFixed(2);
      }

      if (item.poi_price && item.poi_tax_amount) {
        item.poi_total_amount = +parseFloat(
          item.poi_price + item.poi_tax_amount
        ).toFixed(2);
      }

      this.$forceUpdate()

      console.log({item});
    },
    getStores: function() {
      let payload = {}
      PosFnbService.GetStores(payload)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            this.allStores = data.Records
            this.allStoresCinemaIds = [...new Set(data.Records.map(s => s.cinema_id))].filter(x => !!x)
          }
        } else {
          this.$toasted.show(data.message);
        }
      })
      .catch(err => {});
    },
    onSearchRawMaterial: function(value) {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.rawMaterials = this.rawMaterialsCopy.filter(x => {
          if (
            x.rm_name
              .toLowerCase()
              .includes(this.searchRawMaterial.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.rawMaterials = this.rawMaterialsCopy;
      }
    },
    onSearchCinema: function(value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemas = this.cinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemas = this.cinemasCopy;
      }
    },
    onSearchStore: function(value) {
      if (this.searchStore && this.searchStore.length > 0) {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy.filter(
          x => {
            if (
              x.sm_store_name
                .toLowerCase()
                .includes(this.searchStore.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy;
      }
    },
    onSearchToStore: function(value) {
      if (this.searchToStore && this.searchToStore.length > 0) {
        this.finalStoreLevel = this.finalStoreLevelCopy.filter(x => {
          if (
            x.sm_store_name
              .toLowerCase()
              .includes(this.searchToStore.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.finalStoreLevel = this.finalStoreLevelCopy;
      }
    },
    getCinemas: function(cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas"
      // };
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
            this.cinemasCopy = data.Records;
            if(cine_id) {
              this.cinemas = data.Records.filter((x) => x.cine_id == cine_id);
              this.cinemasCopy = data.Records.filter((x) => x.cine_id == cine_id);
            }
            this.cinemasAll = data.Records;
            this.cinemasCopyAll = data.Records;
            this.cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectCinema: function(cinema) {
      this.selected_to_cinema = ''
      this.selectedCinema = cinema.cine_name;
      this.request_body.cinema_id = cinema.cine_id;
      this.getStoreManagementLevel(cinema.cine_id);
    },

    onToCinemaSelect: function (to_cinema) {
      this.selectedFinalStore = "";
      this.request_body.transfer_to_store_management_id = null;
      this.finalStoreLevel = [];
      this.finalStoreLevelCopy = [];

      console.log({ to_cinema })

      if (!this.allStoresCinemaIds.includes(to_cinema.cine_id)) {
        this.$toasted.show(
          "No store found for selected cinema"
        );
        this.$nextTick(() => { this.selected_to_cinema = '' })
        return
      }
    },

    getStoreManagementLevel: function(cinema_id) {
      this.storeManagementsLevels = [];
      this.storeManagementsLevelsCopy = [];
      this.selectedStoreLevel = "";
      // let payload = {
      //   tableName: "store_management",
      //   sm_is_active: "Y",
      //   cinema_id: cinema_id
      //   // sm_parent_id: 0
      // };
      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeManagementsLevels = data.Records;
            this.storeManagementsLevelsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    onSelectMainStoreLevel: function(store) {
      this.getStoreBasedQuantity(store);
      this.request_body.transfer_from_store_management_id = store.sm_id;
      this.selectedStoreLevel = store.sm_store_name;
      this.selectedFinalStore = "";
      this.request_body.transfer_to_store_management_id = null;
      this.finalStoreLevel = [];
      this.finalStoreLevelCopy = [];
      this.finalStoreLevel = this.storeManagementsLevels.filter(x => {
        return x.sm_id !== store.sm_id;
      });
      this.finalStoreLevelCopy = this.finalStoreLevel;
    },

    getStoreBasedQuantity: function(store) {
      this.rawMaterials = [];
      this.rawMaterialsCopy = [];
      let payload = {
        sm_id: store.sm_id
      };
      PosFnbService.GetStoreBasedQuantity(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.rawMaterials = data.Records;
            this.rawMaterialsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    onSelectStoreLevel: function(store) {
      this.selectedFinalStore = store.sm_store_name;
      this.request_body.transfer_to_store_management_id = store.sm_id;
    },

    onSelectRawMaterial: function(rawmaterial, index) {
      this.selectedRawMaterials[index].transfer_quantity = 0

      this.getRelatedUom(index, rawmaterial.rm_id, rawmaterial);
      this.selectedRawMaterials[index].rm_name = rawmaterial.rm_name;
      this.selectedRawMaterials[index].rm_id = rawmaterial.rm_id;
      this.selectedRawMaterials[index].stock_id = rawmaterial.stock_id;
      this.selectedRawMaterials[index].uom_name = rawmaterial.uom_unit;
      this.selectedRawMaterials[index].uom_id = rawmaterial.uom_id;

      this.$nextTick(() => {
        console.log({
            rawmaterial,
            index,
            'conversion_formula': this.selectedRawMaterials[index].conversion_formula,
          },
        )
      })
    },

    onSelectUom: function(item, index) {
      this.selectedRawMaterials[index].uom_name = item.uom_unit;
      this.selectedRawMaterials[index].uom_id = item.uom_id;
    },

    onSelectQty: function(qty, index) {
      this.selectedRawMaterials[index].transfer_quantity = String(qty);
    },

    getRelatedUom: function(index, rm_id, rawmaterial) {
      let loader = this.$loading.show();
      let cinema_id = this.request_body.cinema_id 
      return PosFnbService.getUomFromRawMaterial({ rm_id, cinema_id })
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.selectedRawMaterials[index].uom_units = data.Records;
            this.UnitMeasurement = data.UnitMeasurement;
            let CheckUnit = this.UnitMeasurement.filter(x => {
              return x.conversion_from == rawmaterial.uom_id;
            });
            if (CheckUnit.length > 0) {
              this.selectedRawMaterials[index].stockQuantity = parseInt(
                rawmaterial.final_stock_quantity /
                  parseInt(CheckUnit[0].conversion_formula)
              );
              this.selectedRawMaterials[index].conversion_formula = parseInt(
                CheckUnit[0].conversion_formula
              );
            } else {
              this.selectedRawMaterials[index].stockQuantity = parseInt(
                rawmaterial.final_stock_quantity
              );
              this.selectedRawMaterials[index].conversion_formula = 1;
            }

             if (data.RawMaterialPrice.length > 0) {
              this.selectedRawMaterialPrice = data.RawMaterialPrice;
              let purchaseRate_avg = parseFloat(data.RawMaterialPrice.reduce((acc, {singleRate}) => acc + parseFloat(singleRate), 0) / data.RawMaterialPrice.length)
              let purchaseRate_tax_avg_percent = parseFloat(data.RawMaterialPrice.reduce((acc, {singleTax, singleRate}) => acc + (parseFloat(singleTax * 100) / parseFloat(singleRate)), 0) / data.RawMaterialPrice.length)
              let singleTax = parseFloat(data.RawMaterialPrice.reduce((acc, {singleTax}) => acc + (parseFloat(singleTax)), 0) / data.RawMaterialPrice.length)
              
              this.selectedRawMaterials[index].adjustment_rate = parseFloat(purchaseRate_avg).toFixed(2);
              this.selectedRawMaterials[index].adjustment_tax = purchaseRate_tax_avg_percent
             }
            this.$forceUpdate()

            console.log(CheckUnit, "sdfsdf");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        })
        .finally(() => {
          loader && loader.hide()
          this.$forceUpdate()
        });
    },
    CalculateSelectedRawMaterial: function(value, index) {
      this.$forceUpdate()

      if (value > this.selectedRawMaterials[index].stockQuantity) {
        this.selectedRawMaterials[
          index
        ].transfer_quantity = this.selectedRawMaterials[index].stockQuantity;
        if (this.selectedRawMaterials[index].rm_name == "") {
          this.$toasted.show("Please Select Raw Material");
        } else {
          this.$toasted.show(
            "Max Transfer Quantity is " +
              this.selectedRawMaterials[index].stockQuantity
          );
        }
      } else {
        if (
          this.selectedRawMaterials[index].conversion_formula == 1 &&
          String(value).includes('.')
        ) {
          this.$toasted.show(
            "Invalid Value, Quantity should be number without decimal point"
          );
          this.selectedRawMaterials[index].transfer_quantity = 0
        } else {
          this.selectedRawMaterials[index].transfer_quantity = value;
        }
      }
    },

    addItem: function() {
      this.selectedRawMaterials.push({
        rm_name: "",
        rm_id: null,
        transfer_quantity: "",
        stockQuantity: [],
        stock_id: null,
        uom_units: [],
        uom_name: "",
        conversion_formula: 1
      });
    },

    removeItem: function(index) {
      this.selectedRawMaterials.splice(index, 1);
    },

    onResetForm: function() {
      this.request_body = {
        cinema_id: null,
        transfer_from_store_management_id: null,
        transfer_to_store_management_id: null,
        transfer_quantity: null
      };
      (this.storeManagementsLevels = []),
        (this.storeManagementsLevelsCopy = []),
        (this.finalStoreLevel = []),
        (this.finalStoreLevelCopy = []),
        (this.rawMaterials = []),
        (this.rawMaterialsCopy = []),
        (this.selectedCinema = "");
      this.selectedStoreLevel = "";
      this.selectedFinalStore = "";
      this.selectedQuantity = "";

      this.selectedRawMaterials = [
        {
          rm_name: "",
          rm_id: null,
          stockQuantity: [],
          transfer_quantity: "",
          stock_id: null,
          uom_units: [],
          uom_name: ""
        }
      ];
    },
    RawMaterialsValidation: function() {
      let count = 0;

      this.selectedRawMaterials.map(x => {
        if (x.rm_id == null || x.uom_name.length == 0) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function(flag) {
      this.submitted = true;
      let array = this.selectedRawMaterials.filter(x => {
        return x.transfer_quantity <= 0;
      });
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);

        // return false

        if (
          (this.request_body.cinema_id == null ||
          this.request_body.transfer_from_store_management_id == null ||
          this.request_body.transfer_to_store_management_id == null) && !this.toCinema
        ) {
          console.log('invalid selection 0')
          return;
        }
        else if (
          this.toCinema && !this.selected_to_cinema
        ) {
          console.log('invalid selection 1')
          return;
        }

        if (this.RawMaterialsValidation()) {
          return;
        }
        if (valid) {
          if (this.toCinema && this.selected_to_cinema) {
            this.request_body.to_cinema_id = this.selected_to_cinema.cine_id
          }

          if (array && array.length == 0) {
            this.btenable = true;
            let payload = {
              ...this.request_body,
              selectedRawMaterials: this.selectedRawMaterials
            };
            PosFnbService.TransferStock(payload)
              .then(response => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  this.onResetForm();
                  if (flag) {
                    this.$router.push({
                      path: "transfer-stocks-logs"
                    });
                    this.$toasted.show(data.message);
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          } else {
            this.$toasted.show(
              array[0].rm_name + " quantity is less than or equal to 0"
            );
          }
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/TransferStocks/transferStocks.vue